import React, { Fragment, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Grid } from '@material-ui/core'
import { Input } from '../Input/Input'
import { generateLink } from '../../store/actions/links/links'
import { useToken } from './../../hooks/useToken'

export const CreatePage = () => {
  const [link, setLink] = useState('')
  const dispatch = useDispatch()
  const headers = useToken()

  const isLoading = useSelector((state) => state.loader.isLoading)
  const submitHandler = (event) => {
    event.preventDefault()
    dispatch(generateLink({ link }, headers, clear))
  }

  const changeInputHandler = (event) => {
    setLink(() => event.target.value)
  }
  const clear = () => {
    setLink('')
  }

  return (
    <Fragment>
      <Grid item xs={12}>
        <form onSubmit={submitHandler}>
          <Input
            autoFocus
            fullWidth
            required
            disabled={isLoading}
            type='text'
            label='Insert link'
            value={link}
            onChange={changeInputHandler}
          />
        </form>
      </Grid>
    </Fragment>
  )
}
